import { render } from "./Home.vue?vue&type=template&id=bf33bd8e"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import "./Home.vue?vue&type=style&index=0&id=bf33bd8e&lang=scss"
script.render = render

export default script